var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_5197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5C15.71 7.5 16.0808 8.32167 15.6525 8.8525L15.5892 8.9225L10.5892 13.9225C10.4457 14.066 10.2548 14.1522 10.0522 14.1649C9.84971 14.1776 9.6495 14.116 9.48917 13.9917L9.41084 13.9225L4.41084 8.9225L4.34167 8.84417L4.29667 8.78L4.25167 8.7L4.2375 8.67L4.215 8.61417L4.18834 8.52417L4.18 8.48L4.17167 8.43L4.16833 8.3825V8.28417L4.1725 8.23583L4.18 8.18583L4.18834 8.1425L4.215 8.0525L4.2375 7.99667L4.29584 7.88667L4.35 7.81167L4.41084 7.74417L4.48917 7.675L4.55334 7.63L4.63334 7.585L4.66334 7.57083L4.71917 7.54833L4.80917 7.52167L4.85333 7.51333L4.90333 7.505L4.95084 7.50167L15 7.5Z",
    fill: "#0069AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_5197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown-arrow.451cf4ffc96687256ca9cbcf09675651.svg";
export { ForwardRef as ReactComponent };